<template>
  <div class="">
    <m-category-wrapper @categories="setCategories" :singleCategory="singleCategory">
      <template v-slot="{ categories,imageHandler ,setLinkType}">
        <div class="row">

          <div class="col-12 my-2" v-if="selectedCategories.length > 0">
            <div class="btn btn-primary" @click="backToPreviewCategory()">
              <span>بازگشت</span>
              <i class="bi bi-arrow-left mx-1"></i>
            </div>
          </div>

          <hr>


          <div class="col-12">


            <div class="row text-center">
              <div class="col-lg-2 mb-2" v-for="category in dataCategories" :data-aos="aosAnimation" :key="category.id">
                <div class="categories-312-card p-3 border" @click="showChildren(category)">

                  <div class="">
                    <img :src="category.image" class=" categories-312-card-img" :alt="category.name"/>
                  </div>
                  <p>{{ category.name }}</p>


                </div>
              </div>
            </div>


          </div>

        </div>
      </template>
    </m-category-wrapper>
  </div>
</template>

<script>
import mCategoryWrapper from "../../Wrappers/CategoryWrapper";

export default {
  name: "Categories312",
  components: {mCategoryWrapper},
  props: {
    aosAnimation: {
      default: 'flip-right',
    },
    singleCategory: {
      default: null
    }
  },
  data() {
    return {
      dataCategories: [],
      selectedCategory: null,
      selectedCategories: [],
      originalCategories: [],
    }
  },
  computed: {
    isLastLayer() {
      return this.dataCategories.length === 0 && this.selectedCategory != null
    }
  },
  methods: {
    showChildren(category) {

      if (this.selectedCategories.length == 0) {
        let categoriesClone = Object.assign({}, this.dataCategories);
        this.selectedCategories.push({
          children: categoriesClone,
          event: 'clear',
        })
      }

      this.selectedCategories.push(category)

      let children = category.children;
      this.selectedCategory = category
      if (children.length > 0) {
        this.dataCategories = children
        return ''
      }
      this.dataCategories = []
    },
    setCategories(data) {
      let original = Object.assign({}, data.data.data)
      if (this.singleCategory != null) {
        original = original[0].children
      }
      this.dataCategories = original
      this.originalCategories = original
    },
    backToPreviewCategory() {
      this.selectedCategories = []
      this.dataCategories = this.originalCategories
    },
  },
  watch: {
    isLastLayer: {
      handler: function (newValue, oldValue) {
        if (newValue == true) {
          let result = Object.assign({}, this.selectedCategories)
          delete result[0]
          this.$emit('selectedCategories', result)
        } else {
          this.$emit('isSelectionDone', false)
        }
      },
      deep: true
    },
  }
}
</script>

<style scoped>
.categories-312-card {
  cursor: pointer;
  transition: .3s ease-in-out all;
  border-radius: 4px;
}

.categories-312-card:hover {
  background: #eeeeee;
  transition: .3s ease-in-out all;
}


.categories-312-card-img {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  object-fit: cover;
}
</style>